import React,{ useState,useEffect, useRef  } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useLocation } from "react-router-dom";
import Sidebar from './sidebar';
import { Plus } from 'react-feather';
import api from '../api';
import { checkStoreSetupStatus } from "./storeSetupUtils";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

function SellerProfile(){
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const navigate = useNavigate();
    const location = useLocation();
    const [MobileNoError,setMobileNoError]=useState(false);
    const [setupStatus, setSetupStatus] = useState({
        subscription: false,
        payment: false,
        delivery: false,
        product: false,
    });
    const [ProfileData,setProfileData]=useState({  
        "user_id":'', 
        "first_name":'',
        "last_name":'',
        "username":'',
        "email":'',
        "mobile":'',
        "address":'',
        "p_image":'',               
        "ig":'',
        "tk":'',
        "tw":'',
        "yt":'',
        "fb":'',
    });
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [errorMsgMobile, setErrorMsgMobile] = useState('');
    const [successMsgMobile, setSuccessMsgMobile] = useState('');

    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState("");
    const [mobileLoading, setMobileLoading] = useState(false);
    const [HidePhoneInput, setHidePhoneInput] = useState(false);
    const [originalMobile, setOriginalMobile] = useState("");


    
    const token = localStorage.getItem("access_token");

    const housekeepingTimer = useRef(null);
    
    useEffect(()=>{
        fetchData();
        return () => clearTimeout(housekeepingTimer.current);
    },[]);

    const isValidE164 = (phone) =>
        /^\+[1-9]\d{7,14}$/.test(phone);


    const checkMobileExists = async (mobile) => {
        try {
            const res = await api.post(
                `${baseUrl}/check-mobile/`,
                { mobile },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return { exists: false };
        } catch (error) {
            if (error.response?.status === 409) {
                return {
                    exists: true,
                    message: error.response.data.message,
                };
            }

            throw error;
        }
    };

    const clean = (v) =>
        v === null || v === undefined || v === "null" ? "" : v;

    const housekeeping = (delay = 3000) => {
        clearTimeout(housekeepingTimer.current);

        housekeepingTimer.current = setTimeout(() => {
            setSuccessMsg("");
            setErrorMsg("");
            setSuccessMsgMobile("");
            setErrorMsgMobile("");
            setMobileNoError(false);
        }, delay);
    };

    const fetchData = async () => {
        try {
            const response = await api.get(baseUrl+'/vendor/', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = response.data;

            setProfileData({
                user_id: clean(data.user?.id),
                first_name: clean(data.user?.first_name),
                last_name: clean(data.user?.last_name),
                username: clean(data.user?.username),    
                email: clean(data.user?.email),

                website: clean(data.website),            
                mobile: clean(data.mobile),
                address: clean(data.address),
                //p_image: clean(data.profile_img),

                ig: clean(data.ig),
                tk: clean(data.tk),
                tw: clean(data.tw),
                yt: clean(data.yt),
                fb: clean(data.fb),
            });

            setOriginalMobile(data.mobile);


        } catch (error) {
            //setError('Failed to fetch customer data. Please try again later.');
        } finally {
            //setLoading(false);
        }
    };

    const inputHandler =(event) => {
        setProfileData({
            ...ProfileData,
            [event.target.name]:event.target.value
        });
    };

    const handleFileChange =(event) => {
        setProfileData({
            ...ProfileData,
            [event.target.name]:event.target.files[0]
        })
    };

    const submitHandler = async (event) => {
        event.preventDefault();
        setLoading(true);
        setErrorMsg("");
        setSuccessMsg("");

        
        if (!isValidE164("+"+ProfileData.mobile)) {
            setLoading(false);
            setMobileNoError(true);
            housekeeping();
            return;
        }


        const mobileCheck = await checkMobileExists(ProfileData.mobile);

        if (mobileCheck.exists) {
            setErrorMsg(mobileCheck.message);
            setLoading(false);
            return;
        }

        try {
            /* ---------------- Vendor data ---------------- */
            const formData = new FormData();
            formData.append("user", ProfileData.user_id);
            formData.append("website", ProfileData.website);
            formData.append("address", ProfileData.address || "");
            formData.append("ig", ProfileData.ig);
            formData.append("tk", ProfileData.tk);
            formData.append("tw", ProfileData.tw);
            formData.append("yt", ProfileData.yt);
            formData.append("fb", ProfileData.fb);

            if (ProfileData.p_image) {
                //formData.append("profile_img", ProfileData.p_image);
            }

            await api.put(`${baseUrl}/vendor/`, formData, {
                headers: {
                    "content-type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            });

            /* ---------------- User data ---------------- */
            const formUserData = new FormData();
            formUserData.append("first_name", ProfileData.first_name);
            formUserData.append("last_name", ProfileData.last_name);
            formUserData.append("username", ProfileData.username);
            formUserData.append("email", ProfileData.email);

            await api.put(`${baseUrl}/user/`, formUserData, {
                headers: {
                    "content-type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            });

            // Run setup check only if everything succeeded
            await checkStoreSetupStatus({ navigate, location, setSetupStatus });

            setSuccessMsg("Profile updated successfully");
            housekeeping();
        } catch (error) {
            //console.log(error);

            /* ---------- Extract backend error message ---------- */
            if (error.response && error.response.data) {
                const data = error.response.data;

                // If backend returns field-based errors
                if (typeof data === "object") {
                    const firstKey = Object.keys(data)[0];
                    const firstError = Array.isArray(data[firstKey])
                        ? data[firstKey][0]
                        : data[firstKey];

                    setErrorMsg(firstError);
                } else {
                    setErrorMsg(data);
                }
            } else {
                setErrorMsg("There was a problem. Kindly try again.");
            }
        } finally {
            setLoading(false);
        }
    };
   
    const socialLinks = [        
        {
            name: "Instagram",
            color: "#E4405F", // Instagram Pinkish Red
            icon: (
              <path d="M7 2c-2.8 0-5 2.2-5 5v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm8 2a1 1 0 011 1v1a1 1 0 01-2 0V5a1 1 0 011-1zm-5 3a5 5 0 015 5 5 5 0 01-5 5 5 5 0 01-5-5 5 5 0 015-5zm0 2a3 3 0 100 6 3 3 0 000-6z" />
            ),
        },
        {
          name: "TikTok",
          color: "#000000", // TikTok Black
          icon: (
            <path d="M12 2c-5.5 0-10 4.5-10 10s4.5 10 10 10c5.3 0 9.7-4.1 10-9.4h-3.2c-.3 3.3-3.1 5.9-6.8 5.9-3.8 0-6.8-3.1-6.8-6.8S8.2 4.2 12 4.2c1.3 0 2.5.4 3.5 1l1.5-2.4C15.6 1.4 13.8 1 12 1zM18.6 3.4l-1.6 2.4c.6.3 1.1.7 1.6 1.1V3.4z" />
          ),
        },
        {
        name: "X",
        url: "https://x.com/kadhr_africa",
        color: "#000000", // X (formerly Twitter)
        icon: (
            <path d="M18.244 2H21.556L14.323 10.217L22.8 22H16.155L10.942 14.845L4.674 22H1.36L9.096 13.183L1 2H7.79L12.503 8.574L18.244 2ZM17.082 20H18.92L6.79 4H4.82L17.082 20Z" />
        ),
        },
        {
            name: "YouTube",
            color: "#FF0000", // YouTube Red
            icon: <path d="M21.8 8s-.2-1.4-.8-2a3.7 3.7 0 00-2-1.4C16.7 4 12 4 12 4s-4.7 0-7 .6a3.7 3.7 0 00-2 1.4c-.6.6-.8 2-.8 2S2 9.7 2 11.5v1c0 1.8.2 3.5.2 3.5s.2 1.4.8 2a3.7 3.7 0 002 1.4c2.3.6 7 .6 7 .6s4.7 0 7-.6a3.7 3.7 0 002-1.4c.6-.6.8-2 .8-2s.2-1.7.2-3.5v-1c0-1.8-.2-3.5-.2-3.5zm-12 6.7V9.3l5.3 2.7-5.3 2.7z" />,
        },
        {
          name: "Facebook",
          color: "#1877F2", // Facebook Blue
          icon: (
            <path d="M22 12.1C22 6.5 17.5 2 12 2S2 6.5 2 12.1c0 4.7 3.4 8.6 7.8 9.5v-6.7H7.1V12h2.7V9.7c0-2.6 1.6-4 3.9-4 1.1 0 2.1.1 2.4.1v2.8h-1.6c-1.3 0-1.5.6-1.5 1.4V12h2.7l-.4 2.9h-2.3V22c4.4-.9 7.8-4.8 7.8-9.5z" />
          ),
        },
    ];
    const refresh =() => {
        window.location.reload();
    };


    return (
        <>                            
            <Helmet>
                <title>Profile</title>
                <meta name="description" content={`Profile`} />
            </Helmet>
            <section className="container mtopcon dashb">
                <div className="row">
                    <div className="col-12 col-lg-2 dash-min mb-3">
                            <div className="nav-left-sidebar sidebar-dark pc">
                                <div className="slimScrollDiv" ><div className="menu-list" >
                                    <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                        <a className="d-xl-none d-lg-none" href="#"></a>
                                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"></span>
                                        </button>
                                        <div className="collapse navbar-collapse" id="navbarNav">
                                            <Sidebar/>
                                        </div>
                                    </nav>
                                </div><div className="slimScrollBar"></div><div className="slimScrollRail"></div></div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-10 dash-max">
                            
                            <div className="row mb-3 ph-header-con">
                                <div className="col-7 pt-2"><h6 className="pageheader-title mb-3">Business Profile </h6></div>
                            </div>
                            <div className="row d-flex justify-content-center">
                                <div className="col-12 col-lg-4">
                                    <div className="card shadow-sm border border-secondary border-opacity-10 mb-4 o-inherit">
                                        <div className="card-body">
                                            <h6 className="mb-3 font-bold">Mobile Number</h6>

                                            {!HidePhoneInput && <>
                                                <PhoneInput
                                                    country="ke"
                                                    enableSearch
                                                    value={ProfileData.mobile || ''}
                                                    onChange={(value) =>
                                                        setProfileData((p) => ({ ...p, mobile: value }))
                                                    }
                                                    inputClass="form-control font9 w-100 pt-2 pb-2"
                                                />
                                                {MobileNoError && (
                                                    <p className="text-danger font8 p-0 m-0">
                                                        *Confirm Phone No Format e.g. +254724000000
                                                    </p>
                                                )}
                                            </>}

                                            {!otpSent ? (
                                            <button
                                                className="btn btn-dark col-12 mt-3"
                                                disabled={mobileLoading}
                                                onClick={async () => {
                                                    setMobileNoError(false);
                                                    setErrorMsgMobile("");
                                                    setSuccessMsgMobile("");

                                                    // ✅ BLOCK if already verified
                                                    if (ProfileData.mobile === originalMobile) {
                                                        setSuccessMsgMobile("This number is already verified.");
                                                        housekeeping();
                                                        return;
                                                    }

                                                    if (!isValidE164("+" + ProfileData.mobile)) {
                                                        setMobileNoError(true);
                                                        housekeeping();
                                                        return;
                                                    }

                                                    const mobileCheck = await checkMobileExists(ProfileData.mobile);

                                                    if (mobileCheck.exists) {
                                                        setErrorMsgMobile(mobileCheck.message);
                                                        return;
                                                    }

                                                    setMobileLoading(true);
                                                    try {
                                                        await api.post(
                                                            `${baseUrl}/mobile/send-otp/`,
                                                            { mobile: ProfileData.mobile },
                                                            { headers: { Authorization: `Bearer ${token}` } }
                                                        );
                                                        setOtpSent(true);
                                                        setSuccessMsgMobile("Verification code sent");
                                                        setHidePhoneInput(true);
                                                        housekeeping();
                                                    } catch {
                                                        setErrorMsgMobile("Failed to send verification code");
                                                    } finally {
                                                        setMobileLoading(false);
                                                    }
                                                    housekeeping();
                                                    
                                                }}

                                            >
                                                Update
                                            </button>
                                            ) : (
                                            <>
                                                <p className="mb-3 mt-3 grey-text">Kindly enter the code sent to <b className='text-dark'>+{ProfileData.mobile}</b> to complete or <span onClick={refresh} className='font9 text-blue pointer'>Resend.</span></p>
                                                
                                                <input
                                                type="text"
                                                className="form-control mt-3"
                                                placeholder="Enter 6-digit code"
                                                value={otp}
                                                onChange={(e) => setOtp(e.target.value)}
                                                />

                                                <button
                                                className="btn btn-dark mt-2 col-12"
                                                onClick={async () => {
                                                    try {
                                                    await api.post(
                                                        `${baseUrl}/mobile/verify-otp/`,
                                                        { mobile: ProfileData.mobile, code: otp },
                                                        { headers: { Authorization: `Bearer ${token}` } }
                                                    );
                                                    setSuccessMsgMobile("Mobile number verified & updated");
                                                    setOtpSent(false);
                                                    setHidePhoneInput(false);
                                                    } catch {
                                                    setErrorMsgMobile("Invalid or expired code");
                                                    }
                                                    
                                                    housekeeping();
                                                }}
                                                >
                                                Verify & Update
                                                </button>                                               
                                                
                                            </>
                                            )}
                                            
                                                {successMsgMobile && <p className="text-success mt-4 text-center"><b>{successMsgMobile}</b></p> } 
                                                {errorMsgMobile && <p className="text-danger mt-4 text-center"><b>{errorMsgMobile}</b></p> }  
                                        </div>
                                    </div>

                                    <div className="card shadow-sm border border-secondary border-opacity-10 ">
                                        <div className="card-body mb-4">                        
                                        <form>
                                                <div className="row mb-3">
                                                    <div className="col-6">
                                                        <label htmlFor="fnm" className="form-label font9">Owner Name*</label>
                                                        <input type="text" className="form-control font9" id="lnm" name='first_name' onChange={inputHandler} value={ProfileData.first_name || ''} />
                                                    </div>
                                                    <div className="col-6">
                                                        <label htmlFor="lnm" className="form-label font9">Business Name*</label>
                                                        <input type="text" className="form-control font9" id="lnm" name='username' onChange={inputHandler} value={ProfileData.username || ''} />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-12">
                                                        <label htmlFor="InputEmail" className="form-label font9">Website*</label>
                                                        <input type="text" className="form-control font9" id="InputEmail" aria-describedby="emailHelp"  name='website' onChange={inputHandler} value={ProfileData.website || ''} />
                                                    </div>
                                                </div> 
                                                <div className="row mb-3">
                                                    <div className="col-12">
                                                        <label htmlFor="InputEmail" className="form-label font9">Email address*</label>
                                                        <input type="email" className="form-control font9" id="InputEmail" aria-describedby="emailHelp"  name='email' onChange={inputHandler} value={ProfileData.email || ''} readOnly />
                                                    </div>
                                                </div>   

                                                <div className="mb-3">
                                                    <label htmlFor="InputEmail" className="form-label font9">Business Address</label>
                                                    <textarea type="text" className="form-control font9"  name='address' onChange={inputHandler} value={ProfileData.address}></textarea>
                                                </div>
                                                <label htmlFor="InputEmail" className="form-label font9">
                                                Social media links
                                                </label>
                                                <div className="accordion" id="accordionExamplelnks">  
                                                    <div className="accordion-item">
                                                        <h2 className="accordion-header">
                                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                                
                                                            <ul className="list-unstyled d-flex p-0 m-0">
                                                                {socialLinks.map((social,index) => (
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        fill={social.color} // Assign brand color
                                                                        viewBox="0 0 24 24"
                                                                        className="w18 me-2"
                                                                        key={index}
                                                                    >
                                                                        {social.icon}
                                                                    </svg>
                                                                ))}
                                                            </ul>

                                                        </button>
                                                        </h2>
                                                        <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExamplelnks">
                                                        <div className="accordion-body">                                                            
                                                                <div className="mb-3">
                                                                    <label htmlFor="basic-url" className="form-label font9">Instagram</label>
                                                                    <div className="input-group">
                                                                        <span className="font8 input-group-text" id="basic-addon3">instagram.com/</span>
                                                                        <input type="text" className="form-control" id="basic-url" aria-describedby="basic-addon3 basic-addon4" placeholder='username' name='ig'  onChange={inputHandler} value={ProfileData.ig ?? ""}/>
                                                                    </div>
                                                                </div>
                                                                <div className="mb-3">
                                                                    <label htmlFor="basic-url" className="form-label font9">Tiktok</label>
                                                                    <div className="input-group">
                                                                        <span className="font8 input-group-text" id="basic-addon3">tiktok.com/</span>
                                                                        <input type="text" className="form-control" id="basic-url" aria-describedby="basic-addon3 basic-addon4" placeholder='username' name='tk'  onChange={inputHandler} value={ProfileData.tk ?? ""}/>
                                                                    </div>
                                                                </div>
                                                                <div className="mb-3">
                                                                    <label htmlFor="basic-url" className="form-label font9">X</label>
                                                                    <div className="input-group">
                                                                        <span className="font8 input-group-text" id="basic-addon3">x.com/</span>
                                                                        <input type="text" className="form-control" id="basic-url" aria-describedby="basic-addon3 basic-addon4" placeholder='username' name='tw'  onChange={inputHandler} value={ProfileData.tw ?? ""}/>
                                                                    </div>
                                                                </div>
                                                                <div className="mb-3">
                                                                    <label htmlFor="basic-url" className="form-label font9">Youtube</label>
                                                                    <div className="input-group">
                                                                        <span className="font8 input-group-text" id="basic-addon3">youtube.com/</span>
                                                                        <input type="text" className="form-control" id="basic-url" aria-describedby="basic-addon3 basic-addon4" placeholder='username' name='yt'  onChange={inputHandler} value={ProfileData.yt ?? ""}/>
                                                                    </div>
                                                                </div>
                                                                <div className="mb-3">
                                                                    <label htmlFor="basic-url" className="form-label font9">Facebook</label>
                                                                    <div className="input-group">
                                                                        <span className="font8 input-group-text" id="basic-addon3">facebook.com/</span>
                                                                        <input type="text" className="form-control" id="basic-url" aria-describedby="basic-addon3 basic-addon4" placeholder='username' name='fb'  onChange={inputHandler} value={ProfileData.fb ?? ""}/>
                                                                    </div>
                                                                </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row mt-3 hide">
                                                    <label htmlFor="formFile" className="form-label font9">Logo</label>
                                                    <div className="upimgcon">
                                                        <input type="file" onChange={handleFileChange} name="images[]" id="images2" className="form-control opzero" required/> <button className="btn addimg"><Plus/> </button>
                                                    </div>
                                                    <div className="col-8 p-0">
                                                        <div id="image_preview2">
                                                            <img src={ProfileData.p_image} width='100' className="mb-1"></img>
                                                        </div>
                                                    </div>
                                                </div> 
                                                <div className='mt-5'></div>
                                                { loading === true ? <>
                                                    <button type="button" disabled className="col-12 btn btn-primary big-btn">Loading...</button>
                                                </> : <>
                                                    <button type="button" onClick={submitHandler} className="col-12 btn btn-primary big-btn">Update</button>
                                                </>}
                                                
                                                {successMsg && <p className="text-success mt-4 text-center"><b>{successMsg}</b></p> } 
                                                {errorMsg && <p className="text-danger mt-4 text-center"><b>{errorMsg}</b></p> }   
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SellerProfile;